import { CanActivate, Router } from "@angular/router";
import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { isPlatformServer } from "@angular/common";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Injectable()
export class FreePointsGuard implements CanActivate {
    environmentVariables: any = JSON.parse(
        localStorage.getItem("environmentVariables") || "{}"
    );
    constructor(
        private router: Router,
        private pagesService: StaticPagesService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    canActivate() {
        if (isPlatformServer(this.platformId)) {
            return true;
        }
        this.pagesService.getenvConfig().subscribe((res) => {
            if (res) {
                this.environmentVariables = res;
            }
        });
        if (
            this.environmentVariables &&
            !this.environmentVariables?.DISABLE_REFERRAL_CODE
        ) {
            return true;
        } else {
            this.router.navigate(["/"]);
            return false;
        }

        return false;
    }
}
